import { getQuoteFlowWay } from 'components/common-form/sidePanel/status/cashFlowWayUtils';
import type {
  OwnProps,
  StateProps,
} from 'components/common-form/sidePanel/status/quoted.previously/Quoted.Previously.connect';
import { connect } from 'react-redux';
import {
  getLastQuoteId,
  getQuoteDetails,
  getQuoteResult,
  getRemunerationMode,
  isPriceInconsistent,
} from 'state/addonForm/addonForm.selector';
import { getQuotePricerToBookingInvertedFlow } from 'state/selectors';
import type { AppState } from 'state/state.model';

const mapStateToProps = (state: AppState, { tabId, workspaceType }: OwnProps): StateProps => {
  const quoteId = getLastQuoteId(state, tabId);
  const quoteResult = getQuoteResult(state, quoteId);
  const quoteDetails = getQuoteDetails(state, tabId);
  const remunerationMode = getRemunerationMode(state, tabId);

  const solveResult = quoteResult?.solveResult!;
  const solveResultFormat = quoteResult?.solveResultFormat;
  const solvingModeDetail = quoteDetails?.SolvingMode;
  const solvingMode = solvingModeDetail?.label ?? solvingModeDetail?.id;

  const pricerToBookingInvertedFlow = getQuotePricerToBookingInvertedFlow(state, workspaceType, tabId);

  const flowWay = getQuoteFlowWay(
    workspaceType,
    pricerToBookingInvertedFlow,
    solvingMode,
    remunerationMode,
    solveResult,
  );
  const fxSpot =
    quoteDetails?.MustDisplayFxSpot === true ? quoteDetails.Greeks?.cells?.filter(x => x.name === 'Spot')[0]! : null;

  return {
    solveResult,
    solveResultFormat,
    solvingMode,
    isMultipleSolvingMode: quoteDetails?.IsMultipleSolvingMode ?? false,
    pricedOn: quoteResult?.createdAt!,
    tradeWay: 'Sell',
    flowWay,
    isPriceInconsistentWithForm: isPriceInconsistent(state, tabId),
    fxSpot,
    remunerationMode: remunerationMode!,
    enableReprice: false,
  };
};

export const connectQuotedPreviously = connect(mapStateToProps);
